import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@cmg/design-system';

import type { Contact } from './FirmInvestorContactsPanel';

export type DeleteFirmInvestorContactDialogProps = Readonly<{
  open: boolean;
  contact: Contact | null;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}>;

export function DeleteFirmInvestorContactDialog({
  open,
  contact,
  onClose,
  onConfirm,
}: DeleteFirmInvestorContactDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Investor Contact</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2">
          Are you sure you want to delete {contact?.name}? This contact will be removed from the
          active directory.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="primary">
          Cancel
        </Button>
        <Button onClick={() => void onConfirm()} variant="contained" color="error">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
